import { connect } from 'react-redux';
import { isBottomGridInEditMode } from '../../state/ui/customerService/bottomGrid';
import { isClientsAndLocationsInEditMode } from '../../state/ui/customerService/clientsAndLocations';
import { reportsPaneVisible } from '../../state/ui/reportsSlice';
import { TRootState } from '../../store';
import { isRoutesPaneInEditMode } from '../../state/ui/planning/routes';
import { isTasksPaneInEditMode } from '../../state/ui/planning/tasks';
import { shouldDiscoveryBeInEditMode } from '../../pages/discovery/selectors';
import { isAdminInEditMode } from '../../pages/users/selectors';
import { isManagementInEditMode } from '../../pages/management/selectors';

const mapStateToProps = (state: TRootState) => ({
    discoveryEdit: shouldDiscoveryBeInEditMode(state),
    adminEdit: isAdminInEditMode(state),
    managementEdit: isManagementInEditMode(state),
    reportsEdit: reportsPaneVisible(state),
    clientsAndLocationsEdit: isClientsAndLocationsInEditMode(state),
    bottomGridEdit: isBottomGridInEditMode(state),
    planningRoutesEdit: isRoutesPaneInEditMode(state),
    planningTasksEdit: isTasksPaneInEditMode(state),
});

const mapDispatchToProps = {};

type TStateProps = ReturnType<typeof mapStateToProps>;
type TDispatchProps = typeof mapDispatchToProps;

export type TConnectableProps = TStateProps & TDispatchProps;

export const Connectable = connect(mapStateToProps, mapDispatchToProps);
